// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1LHFc","topBottomGutter":"Layout_topBottomGutter__2B5wB"};